import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import Landing from "@/pages/Landing";
import Confirmation from "@/pages/Confirmation";
import ManageBooking from "@/pages/ManageBooking";
import AdminPage from "@/pages/AdminPage";
import { SignInPage, SignUpPage } from "@/pages/AuthPages";

const ClerkLayout = () => (
  <ClerkAuthProvider>
    <Outlet />
  </ClerkAuthProvider>
);

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/confirmation/:id" element={<Confirmation />} />
        <Route path="/manage" element={<ManageBooking />} />
        <Route element={<ClerkLayout />}>
          <Route path="/admin/*" element={<AdminPage />} />
          <Route path="/sign-in/*" element={<SignInPage />} />
          <Route path="/sign-up/*" element={<SignUpPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
